import { render, staticRenderFns } from "./PriceHeader.vue?vue&type=template&id=28e329b9&scoped=true&"
import script from "./PriceHeader.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PriceHeader.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PriceHeader.vue?vue&type=style&index=0&id=28e329b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e329b9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28e329b9')) {
      api.createRecord('28e329b9', component.options)
    } else {
      api.reload('28e329b9', component.options)
    }
    module.hot.accept("./PriceHeader.vue?vue&type=template&id=28e329b9&scoped=true&", function () {
      api.rerender('28e329b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/components/PriceHeader/PriceHeader.vue"
export default component.exports